import { Outlet, useLocation } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { useAuth } from '../context/AuthContext'

const LandingLayout = () => {
  useAuth()

  const location = useLocation()
  const isHomePage = location.pathname === '/home'

  return (
    <div
      className="enerqiq-landing-layout"
      style={{
        height: '100vh',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#3BC6C4',
        backgroundImage: `
          linear-gradient(
            rgba(59, 198, 196, 0.9),
            rgba(59, 198, 196, 0.9)
          ),
          url('/pattern_5.png')
        `,
        backgroundRepeat: 'repeat',
        backgroundSize: '400px 400px'
      }}
    >
      <Header />

      <main
        className="enerqiq-landing-main"
        style={{
          flex: 1,
          minHeight: 0,
          minWidth: 0,
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box',
          overflowX: 'hidden',
          overflowY: isHomePage ? 'hidden' : 'auto',
          padding: '9px'
        }}
      >
        <Outlet />
      </main>

      <Footer />
    </div>
  )
}

export default LandingLayout